export const SET_ORDERS_DATA = 'SET_ORDERS_DATA';
export const SET_ORDERS_FILTERS = 'SET_ORDERS_FILTERS';
export const SET_CHILD_PARTNERS = 'SET_CHILD_PARTNERS';
export const SET_SHOW_ACTIONS_FOR_ORDER = 'SET_SHOW_ACTIONS_FOR_ORDER';

export const LEFT_PAGE = 'LEFT';
export const RIGHT_PAGE = 'RIGHT';
